import type { ShipNodeChannel } from '@skupreme/shared/components/shipnode';

/**
 * Which installers to link: the build's own environment (`vite build --mode staging|production`). Not
 * `CommonUtility.isStagingEnv()`, which is true only on a local dev server, so a deployed staging build would
 * link the production installers.
 */
export function shipNodeChannel(mode: string = import.meta.env.MODE): ShipNodeChannel {
  return mode === 'production' ? 'production' : 'staging';
}
